module.exports = __webpack_public_path__ + "static/media/TnPuja.e75e63d6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/TnPuja.svg
// module id = 215
// module chunks = 0